<form [formGroup]="formGroup">
    <div class="formWrapper">
        <lsq-input
            [formControlName]="'documentName'"
            [name]="'document-name'"
            label="Document Name*"
            [group]="formGroup"
        >
        </lsq-input>
        <lsq-input
            [formControlName]="'documentDescription'"
            [name]="'document-description'"
            label="Document Description*"
            [group]="formGroup"
        >
        </lsq-input>
        <lsq-select
            id="file-format-select"
            [options]="fileOptions"
            [formControlName]="'fileFormat'"
            [group]="formGroup"
            label="Allowed File Format*"
            [disabled]="formGroup.value.hasDocuments"
        >
        </lsq-select>
        <dr-schedule-document-request
            *ngIf="schemaType !== 'Prospect'"
            [formGroup]="formGroup"
            [fieldSchema]="fieldSchema"
        ></dr-schedule-document-request>
        <div class="invite-error" *ngIf="formGroup.errors?.err">
            {{ formGroup.errors?.err }}
        </div>
    </div>
</form>
